var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9472 14.2905C20.6047 14.9557 20.1332 16.0833 19.198 16.0833H16.7917V18.0208C16.7917 19.0903 15.925 19.9583 14.8542 19.9583C13.7834 19.9583 12.9167 19.0903 12.9167 18.0208V16.0833H10.5103C9.57512 16.0833 9.10367 14.9557 9.76112 14.2905L14.0223 9.97375C14.4796 9.51004 15.2287 9.51004 15.686 9.97375L19.9472 14.2905ZM31 16.7007C31 22.0715 26.6548 26.4167 21.3125 26.4167H7.10417C3.18654 26.4167 0 23.2301 0 19.3125C0 17.1477 0.915792 15.0216 2.45029 13.6266C2.59883 13.4922 2.68408 13.3037 2.65825 13.1706C2.41542 11.9216 2.40121 10.6402 2.61433 9.35762C3.33637 5.00987 6.727 1.55596 11.0528 0.765456C15.7958 -0.105127 20.5349 2.30771 22.5861 6.62962C22.6636 6.79366 22.8121 6.90346 23.0046 6.94221C27.6352 7.86575 30.9974 11.9694 30.9974 16.7007H31ZM27.125 16.7292C27.125 13.8113 25.0725 11.3055 22.2464 10.741C20.841 10.4581 19.6902 9.56558 19.0857 8.28812C17.9529 5.89725 15.615 4.45962 13.0342 4.45962C12.6118 4.45962 12.1843 4.49708 11.7529 4.57716C9.07137 5.068 6.88587 7.29483 6.43896 9.99312C6.30204 10.8185 6.30979 11.6387 6.46479 12.4318C6.74767 13.8914 6.20904 15.4478 5.05946 16.4941C4.34129 17.1477 3.87629 18.2533 3.87629 19.3138C3.87629 21.095 5.32554 22.543 7.10546 22.543H21.3138C24.5184 22.543 27.1263 19.9351 27.1263 16.7305L27.125 16.7292Z",
    fill: "url(#paint0_linear_217_1492)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_1492",
    x1: 4.05952,
    y1: 3.90474,
    x2: 28.0476,
    y2: 26.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8761F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloudIcon.f14ca28f051867c1b1494991641aeb5a.svg";
export { ForwardRef as ReactComponent };